var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRichToTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8002 3.0002C20.8002 3.44202 20.442 3.8002 20.0002 3.8002L4.0002 3.8002C3.55837 3.8002 3.2002 3.44202 3.2002 3.0002C3.2002 2.55837 3.55837 2.2002 4.0002 2.2002H20.0002C20.442 2.2002 20.8002 2.55837 20.8002 3.0002ZM12.8006 8.83517L18.4558 14.0864C18.7796 14.3871 19.2858 14.3683 19.5864 14.0446C19.8871 13.7208 19.8683 13.2146 19.5446 12.914L12.5446 6.41396C12.2376 6.12894 11.7628 6.12894 11.4558 6.41396L4.45584 12.914C4.13207 13.2146 4.11332 13.7208 4.41396 14.0446C4.7146 14.3683 5.22079 14.3871 5.54456 14.0864L11.2006 8.83436L11.2004 21.9998C11.2004 22.4416 11.5586 22.7998 12.0004 22.7998C12.4422 22.7998 12.8004 22.4417 12.8004 21.9998L12.8006 8.83517Z",
    fill: "#7B7E86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRichToTop);
export default __webpack_public_path__ + "static/media/rich-to-top.4b5405e37f3eddacda5891a0aa76c204.svg";
export { ForwardRef as ReactComponent };